import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/components/DashboardLayout';
import EvidenceVault from '@/pages/EvidenceVault';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function EvidencePage({ token, user }) {
  const navigate = useNavigate();

  return (
    <DashboardLayout user={user} token={token}>
      <div className="container mx-auto px-4 py-4 sm:py-6 lg:py-8 w-full min-w-0">
        <div className="flex items-center gap-4 mb-4 sm:mb-6">
          <div className="min-w-0">
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold" style={{ color: '#ef4444' }}>Evidence Vault</h1>
            <p className="text-xs sm:text-sm" style={{ color: '#666' }}>View misuse evidence and security alerts</p>
          </div>
        </div>
        <EvidenceVault token={token} />
      </div>
    </DashboardLayout>
  );
}
